<template>
  <div class="user-wrapper">
    <div class="content-box">
      <span v-if="!accountProxy" class="info-small" @click.stop="doClick">
        <a-badge :count="number" :overflow-count="99" title="消息">
          <sass-icon type="hi-tongzhi" style="font-size: 16px;" class="info-icon"/>
        </a-badge>
      </span>
      <span class="learn-center" title="帮助中心" @click.stop="toHelpDoc">
        <sass-icon type="hi-yiwen1" style="font-size: 16px;" class="info-icon"/>
      </span>
      <span v-if="!showRobotIcon && hasAgent" class="robot" title="智能助手" @click.stop="showRobot">
        <img src="@/assets/images/lingxin.png" />
      </span>
      <span v-if="isAsyncing" class="import-upload" title="文件处理中...." @click.stop="$store.commit('setimportTipsVisible', true)">
        <a-icon type="sync" spin style="font-size: 16px;" class="info-icon" />
      </span>
      <a-dropdown placement="bottomRight" :overlayStyle="{paddingTop: '8px'}" overlayClassName="top-user-menu">
        <span class="action ant-dropdown-link user-dropdown-menu" style="display: flex; padding-right: 4px; align-items: center;">
          <avatar :size="24" :src="avatar" :bg-color="avatarBg" />
          <span style="font-size: 14px; color: #fff;">
            {{ accountProxy ? proxyName : nickname}}
            <span v-if="accountProxy" class="proxy">
              <span class="tag">代理</span>
            </span>
            <sass-icon type="hi-gengduo" style="font-size: 10px; margin-left: 4px; vertical-align: .15em;" />
          </span>
        </span>
        <a-menu slot="overlay" class="user-dropdown-menu-wrapper">
          <template v-if="accountProxy">
            <a-menu-item  @click="cancelProxy">
              <common-icon type="_gerenzhanghushezhi" :size="16" class="info-icon" style="margin-right:13px;"/>
              <span style="font-weight: bolder;font-size:12px;">退出代理</span>
            </a-menu-item>
          </template>
          <template v-else>
            <a-menu-item key="0" class="user-info">
            <div class="content">
              <avatar :size="32" :src="avatar" :bg-color="avatarBg" />
              <div class="info">
                <!-- <span class="name">{{ username }}</span> -->
                <!-- <span class="tag">{{ roleTag }}</span> -->
                <text-tooltip class="name" :content="username" refName="name"/>
              </div>
            </div>
          </a-menu-item>
          <a-divider class="menu-divider"/>
          <a-menu-item key="1">
            <div class="title-01">当前企业</div>
            <text-tooltip class="c-gray" :content="tenantFullName" refName="name"/>
            <!-- <div class="c-gray">{{ tenantFullName }}</div> -->
          </a-menu-item>
          <a-divider class="menu-divider"/>
          <a-menu-item key="2">
            <a href="javascript:;" @click="handelPerson">
              <sass-icon type="hi-gerenxinxishezhi" style="font-size: 16px;" />
              <span>个人信息设置</span>
            </a>
          </a-menu-item>
          <a-divider class="menu-divider"/>
          <a-menu-item key="3">
            <a href="javascript:;" @click="switchCompanies = true">
              <sass-icon type="hi-qiehuan" style="font-size: 16px;" />
              <span>切换企业</span>
            </a>
          </a-menu-item>
          <a-divider class="menu-divider"/>
          <a-menu-item v-show="isEms" key="4">
            <a href="javascript:;" @click="navTo('appointment')">
              <sass-icon type="hi-zhiwuweituo" style="font-size: 16px;" />
              <span>职务委托</span>
            </a>
          </a-menu-item>
          <a-divider v-show="isEms" class="menu-divider"/>
          <a-menu-item v-show="isEms" key="5">
            <a href="javascript:;" @click="navTo('invoice_tiltle')">
              <sass-icon type="hi-gongsifapiaotaitou" style="font-size: 16px;" />
              <span>公司发票抬头</span>
            </a>
          </a-menu-item>
          <a-divider v-show="isEms" class="menu-divider"/>
          <a-menu-item v-if="isTenantAdmin" key="6">
            <a href="javascript:;" @click="transferAdmin = true">
              <sass-icon type="hi-zhuanyi" style="font-size: 16px;" />
              <span>转移企业管理员</span>
            </a>
          </a-menu-item>
        <!-- <a-menu-item v-show="isFins"  key="7">
          <a href="javascript:;"  @click="defaultVisible = true">
            <common-icon type="_gerenxinxishezhi" :size="16" />
            <span>默认设置</span>
          </a>
        </a-menu-item> -->
          <!-- <a-divider v-if="!accountProxy" class="menu-divider"/> -->
          <!-- <a-menu-item key="8">
            <a href="javascript:;" @click="handleLogout">
              <common-icon type="_tuichu" :size="16" />
              <span>退出账号</span>
            </a>
          </a-menu-item> -->
          </template>
          <template v-if="proxyList.length">
            <a-menu-item v-show="isEms" key="8">
              <span style="font-size: 12px;">职务代理</span>
            </a-menu-item>
            <a-divider class="menu-divider"/>
            <a-menu-item v-show="isEms" key="9">
              <a v-for="item in proxyList.slice(0, 2)" :key="item.id" href="javascript:;" @click="doProxy(item)">
                <sass-icon type="hi-daili" style="font-size: 16px;" />
                <span style="margin: 0 24px 0 12px; line-height: 12px;">代理</span>
                <a-avatar :size="28" style="margin-right: 6px; color: #fff; background: #60d5b7;">{{ item.userName.charAt(0) }}</a-avatar>
                <span>{{ item.userName }}</span>
              </a>
            </a-menu-item>
          </template>
          <template v-if="proxyList.length > 2">
             <a-menu-item v-show="isEms" key="10">
                <a href="javascript:;" @click="showProxyModal">
                  <span style="color: #00a497; font-size: 12px;">更多代理角色</span>
                </a>
             </a-menu-item>
          </template>
          <a-menu-item v-show="isFins || isFas"  key="11">
            <a href="javascript:;"  @click="defaultVisible = true">
              <sass-icon type="hi-gerenxinxishezhi" style="font-size: 16px;" />
              <span>默认设置</span>
            </a>
          </a-menu-item>
          <a-divider class="menu-divider"/>
          <a-menu-item>
            <a href="javascript:;" @click="importDowloadVisible=true;">
              <sass-icon type="hi-daochu" :size="16" />
              <span>我的导入导出</span>
            </a>
          </a-menu-item>
          <a-divider class="menu-divider"/>
          <a-menu-item key="12">
            <a href="javascript:;" @click="jumpPortal">
              <sass-icon type="hi-morenshezhi" style="font-size: 16px;" />
              <span>返回门户</span>
            </a>
          </a-menu-item>
          <a-divider class="menu-divider"/>
          <a-menu-item key="13">
            <a href="javascript:;" @click="handleLogout">
              <sass-icon type="hi-tuichu" style="font-size: 16px;" />
              <span>退出账号</span>
            </a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
    <switch-companies v-model="switchCompanies" />
    <transfer-admin v-if="transferAdmin" v-model="transferAdmin" />
    <personal-info v-if="personal" :isVisible="personal" @close="personal = false"/>
    <select-proxy v-model="proxyModal" @select="doProxy" />
    <popup ref="popup"/>
    <!-- 默认设置 - 总账 -->
    <set-default-account-book v-show="isFins || isFas" :type="isFins ? 'isFins' : 'isFas'"  :visible.sync="defaultVisible" />
    <!-- 我的导入导出弹窗 -->
    <my-import-dowload :visible.sync="importDowloadVisible" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CommonIcon from '@/components/common-icon'
import SwitchCompanies from './modules/SwitchCompanies'
import TransferAdmin from './modules/TransferAdmin'
import PersonalInfo from './modules/PersonalInfo'
import Avatar from '@/components/Avatar'
import popup from './popup'
import setDefaultAccountBook from './setDefaultAccountBook'
import { SetProxy, ExitProxy } from '@/api/proxy'
import SelectProxy from './modules/SelectProxy'
import TextTooltip from '@/components/TextTooltip'
import MyImportDowload from '../MyImportDowload/MyImportDowload.vue'
export default {
  name: 'UserMenu',
  components: {
    CommonIcon,
    SwitchCompanies,
    TransferAdmin,
    PersonalInfo,
    Avatar,
    popup,
    setDefaultAccountBook,
    SelectProxy,
    TextTooltip,
    MyImportDowload
  },
  data() {
    return {
      account: false,
      switchCompanies: false,
      transferAdmin: false,
      personal: false,
      defaultVisible: false,
      proxyModal: false
    }
  },
  computed: {
    ...mapGetters(['tenantFullName', 'avatar', 'avatarBg', 'roleTag', 'isTenantAdmin', 'showMicroApp', 'currentMicroApp', 'proxyList', 'accountProxy', 'proxyUserName', 'showRobotIcon', 'mobile', 'hasAgent']),
    number () {
      return this.$store.state.user.number
    },
    username () {
      return this.$store.state.user.name
    },
    nickname () {
      const name = this.$store.state.user.name
      let nickname = ''
      let len = 0
      for (const i of name) {
        const c = i.charCodeAt(i)
        if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
          len++
        } else {
          len += 2
        }
        // 当长度===6 则取全部 否则取前5
        if (len < 6 || (len === 6 && (nickname + i) === name)) {
          nickname += i
        }
      }
      // 总长度超过6  加上...
      if (len > 6) nickname += '...'
      return nickname
    },
    proxyName () {
      const name = this.proxyUserName
      let proxyName = ''
      let len = 0
      for (const i of name) {
        const c = i.charCodeAt(i)
        if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
          len++
        } else {
          len += 2
        }
        // 当长度===6 则取全部 否则取前5
        if (len < 6 || (len === 6 && (proxyName + i) === name)) {
          proxyName += i
        }
      }
      // 总长度超过6  加上...
      if (len > 6) proxyName += '...'
      return proxyName
    },
    isFins () {
      return this.showMicroApp === 'fins'
    },
    isFas () {
      return this.showMicroApp === 'fas'
    },
    isEms () {
      return this.showMicroApp === 'ems'
    },
    importDowloadVisible: {
      get () {
        return this.$store.state.user.importDowloadVisible
      },
      set (val) {
        this.$store.commit('setImportDowloadVisible', val)
      }
    },
    // 有正在处理中的异步任务
    isAsyncing() {
      const tasks = this.$store.state.user.userFileTask || []
      return tasks && tasks.filter(item => [1, 2].includes(item.taskStatus)).length > 0
    }
  },
  watch: {
    '$store.state.tabs.activePath' (val) {
      console.log('ActiveTabChanged', val)
      this.personal = false
      this.$refs.popup && this.$refs.popup.close()
    }
  },
  methods: {
    ...mapActions(['setAccountProxy', 'Logout']),
    handleLogout() {
      this.Logout()
    },
    showRobot() {
      this.$store.commit('setShowRoobtIcon', true)
      localStorage.setItem(`${this.mobile}_showRobotIcon`, '1')
    },
    async navTo (name) {
      const { currentMicroApp } = this
      console.log(currentMicroApp)
      await currentMicroApp.update({ to: { name } })
      // console.log(this.$route)
      this.$emit('show', false)
    },
    handelPerson() {
      this.personal = true
    },
    showProxyModal () {
      this.proxyModal = true
      this.$emit('show', false)
    },
    async doProxy (item) {
      const { id, proxyUserId, proxyUserName, userId, userName } = item
      const res = await SetProxy({ id, proxyUserId, proxyUserName, userId, userName })
      if (!res) return false
      item.userId = res.data
      this.setAccountProxy(item)
      this.$emit('show', false)
    },
    async cancelProxy () {
      const res = await ExitProxy()
      if (!res) return false
      this.setAccountProxy(false)
      this.$emit('show', false)
    },
    doClick () {
      this.$refs.popup.open()
    },
    toHelpDoc () {
      const bases = {
        dev: 'https://dev-help.weihaizixun.com',
        test: 'https://tes-help.weihaizixun.com',
        pre: 'https://pre-help.weihaizixun.com',
        pro: 'https://help.weihaizixun.com'
      }
      const userId = this.$store.state.user.userId
      const env = process.env.VUE_APP_ENV || 'pro'
      const baseURL = (bases[env] ? bases[env] : bases.pro) + `/#/center/updateLog??userName=${this.username}&headPic=null&sysCode=sys_44&id=${userId}&code=`
      window.open(baseURL, '_blank')
    },
    // 跳转门户
    jumpPortal () {
      const url = document.location.origin + '/portal-web/home/index'
      window.open(url, '_blank')
    }
  }
}
</script>
<style lang="less" scoped>
  .proxy {
    .tag {
      display: inline;
      padding: 1px 3px;
      font-size: 5px;
      line-height: 5px;
      color: #6266bf;
      background: #FFFFFF;
      border: 0 solid #B4B5F9;
      border-radius: 3px;
    }
  }
  .content-box {
    display: flex;
    overflow: hidden;
  }
  .info-small {
    position: relative;
    margin-top: 5px;
    // margin-right: 5px;
    line-height: 36px;
    // position: absolute;
    // top: 2px;
    // right: 170px;
    margin: 5px 16px 0 10px;
    color: #fff;
    cursor: pointer;
    .info-icon {
      color: #fff;
    }
    .info-number {
      position: absolute;
      top: 0;
      right: -8px;
      z-index: 100;
      border-radius: 9px;
      width: 16px;
      height: 16px;
      font-size: 12px;
      line-height: 15px;
      text-align: center;
      color: #fff;
      background: red;
    }
  ::v-deep.ant-badge-count {
      min-width: 18px;
      height: 18px;
      padding: 0;
      line-height: 18px;
      background: #f5222d;
      border-radius: 8px;
      box-shadow: 0 0 0 1px transparent;
    }
  }
  .learn-center {
    position: relative;
    margin: 5px 4px 0 0;
    line-height: 36px;
    color: #fff;
    cursor: pointer;
    .info-icon {
      color: #fff;
    }
    .learn-number {
      position: absolute;
      top: 0;
      right: -8px;
      z-index: 100;
      border-radius: 9px;
      width: 16px;
      height: 16px;
      font-size: 12px;
      line-height: 15px;
      text-align: center;
      color: #fff;
      background: red;
    }
  }
  .import-upload {
    color: #fff;
    cursor: pointer;
    margin: 5px 0px 0 5px;
    line-height: 36px;
  }
  .robot {
    cursor: pointer;
    margin-left: 10px;
    padding-top: 12px;
    img {
      height: 22px;
    }
  }
  .user-info {
    display: flex;
    height: 64px;
    color: #fff;
    background-repeat: no-repeat;
    background-size: cover;
    align-items: center;
    &,
    &.ant-dropdown-menu-item:hover {
      // background-image: url('./images/bg.png');
      background-repeat: no-repeat;
      background-size: cover;
    }
    .content {
      display: flex;
      align-items: center;
    }
    .info {
      display: flex;
      margin-left: 8px;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
      .name {
        width: 180px;
        margin-bottom: 4px;
        font-size: 14px;
        color: rgba(51, 51, 51, .85);
      }
      .tag {
        border: 1px solid #fff;
        border-radius: 20px;
        padding: 0 5px;
        font-size: 12px;
        line-height: 20px;
      }
    }
  }
  .title-01 {
    font-size: 14px;
    color: rgba(51, 51, 51, .85);
  }
  .c-gray {
    font-size: 12px;
    color: #bbb;
  }
  .user-dropdown-menu-wrapper {
    overflow: hidden;
    padding: 0 0 8px !important;
    ::v-deep {
      .ant-dropdown-menu-item > a {
        display: flex;
        font-size: 12px;
        align-items: center;
        & > span:last-child {
          margin-left: 12px;
        }
      }
      .ant-dropdown-menu-item {
        padding: 8px 16px;
        width: 260px !important;
        &:hover {
          background: #fafafa;
        }
      }
    }
  }
  .user-wrapper .action .avatar {
    display: flex;
    margin: 0 8px 0 0 !important;
  }
  .menu-divider {
    margin: 0 auto;
    width: 228px;
    min-width: auto;
    background: #f5f5f5;
  }
</style>
